import { apiCall } from 'store/services/service';
import { URL_ARTICLES } from 'store/services/URL';
import { Article } from 'views/articles/articleTypes';

export interface FetchArticlesResult {
  articles: Article[];
  hasMore: boolean;
  unreadCount: number;
}

/** Fetch a batch: GET /articles?offset=&limit= -> { articles, hasMore, unreadCount } */
export async function fetchArticleBatch(
  offset: number,
  limit: number,
): Promise<FetchArticlesResult> {
  const res: any = await apiCall.get({
    url: `${URL_ARTICLES}?offset=${offset}&limit=${limit}`,
    isAuthToken: true,
    params: {},
  });

  if (res && Array.isArray(res.articles)) {
    return { articles: res.articles, hasMore: !!res.hasMore, unreadCount: res.unreadCount || 0 };
  }
  return { articles: [], hasMore: false, unreadCount: 0 };
}

/**
 * Content-based related articles ("more like this"):
 * GET /articles/<id>/related?limit= -> { articles }
 * The backend ranks by full-text relevance to the source article and falls
 * back to latest articles, so the current one is already excluded.
 */
export async function fetchRelatedArticles(id: number, limit = 4): Promise<Article[]> {
  const res: any = await apiCall.get({
    url: `${URL_ARTICLES}/${id}/related?limit=${limit}`,
    isAuthToken: true,
    params: {},
  });

  if (res && Array.isArray(res.articles)) {
    return res.articles;
  }
  return [];
}
